import { Action } from "redux"

import * as actions from "./actions"
import { buildNormalizedNameLUT } from "./searchprotocol"
import { ISearch } from "./index"

export const initialState: ISearch = {
    isInitialized: false,
    isShown: false,
    workspaceId: -1,
    normalizedNameLUT: {},
}

const ACTION_HANDLERS: {
    [action: string]: (state: ISearch, props: Action) => ISearch
} = {
    [actions.INITIALIZE]: (
        state,
        { smartSearchInitData, workspaceId }: actions.Initialize,
    ): ISearch => ({
        ...state,
        normalizedNameLUT: !!smartSearchInitData
            ? buildNormalizedNameLUT(smartSearchInitData.fieldLabels)
            : {},
        workspaceId,
    }),

    [actions.SET_INITIALIZED]: (state) => ({
        ...state,
        isInitialized: true,
    }),

    [actions.UPDATE_VISIBILITY]: (
        state,
        { visibility }: actions.UpdateVisibility,
    ): ISearch => ({
        ...state,
        isShown: visibility,
    }),
}

export default function reducer(state = initialState, action: Action): ISearch {
    const handler: (state: ISearch, action: Action) => ISearch =
        ACTION_HANDLERS[action.type]
    return handler ? handler(state, action) : state
}
